<template>
  <div id="page-payments-check">
    <v-container grid-list-xl fluid>

      <!-- Breadcrumb + header -->
      <breadcrumbs
        :routelinks="[
          { text: 'Payments', href: '#/payments' },
          { text: 'Check', href: '#/payments/check', disabled: true }
        ]"
      />

      <div class="modern-page-header">
        <div class="modern-page-header__left">
          <div class="modern-page-header__icon-wrap">
            <v-icon class="modern-page-header__icon">receipt_long</v-icon>
          </div>
          <div>
            <h3 class="modern-page-header__title">Payment Details</h3>
            <p class="modern-page-header__sub">Update subscription dates and status</p>
          </div>
        </div>
      </div>

      <v-layout row wrap>
        <!-- Main form -->
        <v-flex lg8 md8 xs12>
          <v-widget enable-header title="Subscription Information">
            <div slot="widget-content">
              <submit-form v-if="isVisible === 0" />
            </div>
          </v-widget>
        </v-flex>

        <!-- Side nav -->
        <v-flex lg4 md4 xs12>
          <payment-info-nav v-on:listChanged="listChanged" />
        </v-flex>
      </v-layout>

    </v-container>
  </div>
</template>

<script>
import Breadcrumbs from "@/components/Breadcrumbs";
import VWidget from "@/components/VWidget";
import PaymentInfoNav from "@/components/payments/PaymentInfoNav";
import SubmitForm from "@/components/payments/SubmitForm";
export default {
  components: { VWidget, PaymentInfoNav, SubmitForm, Breadcrumbs },
  data() {
    return { isVisible: 0 };
  },
  methods: {
    listChanged: function(index) {
      this.isVisible = index;
    }
  }
};
</script>

<style scoped lang="css">
.modern-page-header {
  display: flex;
  align-items: center;
  padding: 4px 0 20px;
  gap: 16px;
}

.modern-page-header__left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.modern-page-header__icon-wrap {
  width: 48px;
  height: 48px;
  border-radius: 14px;
  background: linear-gradient(135deg, #43A047, #2e7d32);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modern-page-header__icon {
  color: #ffffff !important;
  font-size: 22px !important;
}

.modern-page-header__title {
  font-family: 'Inter', 'Roboto', sans-serif;
  font-size: 1.3rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
  letter-spacing: -0.3px;
}

.modern-page-header__sub {
  font-family: 'Inter', 'Roboto', sans-serif;
  font-size: 13px;
  color: #64748b;
  margin: 2px 0 0;
}
</style>
